module.exports = __webpack_public_path__ + "img/card2_img_2.aeeb5e25.jpg";